export default [
{
    path: '/management/bylaws',
    name: 'view_bylaws',
    component: () => import('@/views/management/index'),
    meta: {
      pageTitle: 'bylaws',
      navActiveLink: 'Management',
      breadcrumb: [{text: 'Management'}, {text: 'Bylaws', active: true}]
    },
  },
  {
    path: '/management/bylaws/:id',
    name: 'management_bylaw',
    component: () => import('@/views/management/components/show'),
    meta: {
      pageTitle: 'bylaws',
      navActiveLink: 'Management',
      breadcrumb: [ {text: 'Management', to: '/management/bylaws'}, {
        text: 'bylaw',
        active: true
      }]
    },
  },
]